<template>
  <section class='service-end-notice service-end-notice--guest'>
    <div class='service-end-notice__content'>
      <p class='service-end-notice__label'>重要なお知らせ</p>
      <h2>Donblerはサービスを終了いたしました</h2>
      <p v-for='message in messages' :key='message'>
        {{ message }}
      </p>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    messages() {
      return [
        'サービス終了に伴い、新規会員登録の受付は終了いたしました。',
        'これまで支えてくださった皆さまに、心より感謝申し上げます。',
      ];
    },
  },
};
</script>

<style lang="scss">
.service-end-notice {
  padding: 20px 24px;
  border-radius: 12px;
  margin: 0 auto 24px;
  max-width: 1170px;
  border: 1px solid #f2d39c;
  background: linear-gradient(135deg, #fff7e8 0%, #fffdf7 100%);
  box-shadow: 0 10px 30px rgba(32, 44, 49, 0.06);
}

.service-end-notice--guest {
  position: fixed;
  top: 88px;
  right: 24px;
  left: 24px;
  z-index: 90;
  max-width: 560px;
  margin: 0 0 24px auto;
}

.service-end-notice__content {
  h2 {
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 8px;
  }
  p {
    font-size: 14px;
    line-height: 1.8;
    margin-top: 6px;
  }
}

.service-end-notice__label {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  color: #9a5b00;
  background-color: #ffe7bf;
  border-radius: 999px;
  padding: 4px 10px;
  margin-bottom: 10px;
}

@media screen and (max-width: 650px) {
.service-end-notice {
  margin: 0 15px 16px;
  padding: 16px;
}

.service-end-notice--guest {
  top: 72px;
  right: 12px;
  left: 12px;
  max-width: none;
  margin: 0;
}

.service-end-notice__content {
  h2 {
    font-size: 18px;
  }
  p {
    font-size: 12px;
    line-height: 1.7;
  }
}
}
</style>
